import * as stylex from "@stylexjs/stylex";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { Grid } from "../../materials";
import { breakpoints, colors, layoutAreas, zIndex } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
const styles = {
    anchor: {
        kVAEAm: "x1uhb9sk x1tks1q0",
        k1xSpc: "x78zum5",
        kwnvtZ: "x1a02dak",
        kjj79g: "x1qughib",
        kGNEyG: "x6s0dn4",
        kaIpWk: "x1cum3z5",
        kGVxlE: "x1gnnqk1 xc9fd2f",
        kmVPX3: "xon2cxt xw755co",
        kMwMTN: "xjsf6ib",
        kWkggS: "x12peec7",
        kzqmXN: "xh8yej3",
        kI3sdo: "x1a2a7pz",
        kMzoRj: "xmkeg23 x1vph9r1",
        ksu8eU: "x1y0btm7 x1u0rt37",
        kVAM5u: "x12a9do8",
        kDPRdz: "x1hs8z84",
        kJuGS5: "x1277o0a",
        kPJHz1: "x784prv",
        k7shQP: "x9v5kkp",
        kZs9gx: "x1892j4j",
        kiEn40: "x7s97pk",
        $$css: true
    },
    label: {
        kMwMTN: "x15rks2t",
        k1xSpc: "x1rg5ohu",
        kmVPX3: "x145yvwc",
        khDVqt: "xuxw1ft",
        $$css: true
    },
    mark: {
        khDVqt: "xuxw1ft",
        k9WMMc: "x2b8uid",
        k1xSpc: "x1rg5ohu",
        kWkggS: "xtwfq29",
        kaIpWk: "xgqmno8",
        kmVPX3: "x87gyiv",
        k7Eaqz: "x1jn76jz",
        k63SB2: "x117nqv4",
        $$css: true
    }
};
export const IndicatorReference = (props)=>{
    return <Grid layout={"article"}>
      <aside id={props.label || props.id} className="x199luj4 x1qmwusi x1uhb9sk x1pb8loi xati1ur x1c4vshn x1qh9dij x12peec7 x1xaadd7">
        <Link href={`/indicators#${props.id}`} {...stylex.props(typography.body2Alt, styles.anchor)}>
          <span {...stylex.props(typography.body2Alt, styles.label)}>
            <FormattedMessage id="SDG indicator" defaultMessage="SDG indicator"/>
          </span>
          <span {...stylex.props(typography.body2Alt, styles.mark)}>
            <span className="x1vc0dw">{props.label || props.id}</span>
          </span>
        </Link>
      </aside>
      {props.children}
    </Grid>;
};
